import { useEffect, useState } from 'react';

/** True while the media query matches; `fallback` when matchMedia is unavailable (jsdom, SSR). */
export default function useMediaQuery(query, fallback = true) {
  const read = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? !!window.matchMedia(query)?.matches : fallback);
  const [matches, setMatches] = useState(read);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    if (!mql) return undefined;
    const onChange = () => setMatches(!!mql.matches);
    onChange();
    mql.addEventListener?.('change', onChange);
    return () => mql.removeEventListener?.('change', onChange);
  }, [query]);
  return matches;
}
